import {
    GET_QUALITY_ENTRY_LIST_PROGRESS, GET_QUALITY_ENTRY_LIST_SUCCESS, GET_QUALITY_ENTRY_LIST_FAILURE,
    ADD_QUALITY_ENTRY_PROGRESS, ADD_QUALITY_ENTRY_SUCCESS, ADD_QUALITY_ENTRY_FAILURE,
    EDIT_DELETE_QUALITY_ENTRY_PROGRESS, EDIT_DELETE_QUALITY_ENTRY_SUCCESS, EDIT_DELETE_QUALITY_ENTRY_FAILURE,
    ////


    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    quality_entry: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const quality_entry_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_QUALITY_ENTRY_LIST_SUCCESS:
            return { ...state, quality_entry: action.quality_entry, loading: false };
        case GET_QUALITY_ENTRY_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_QUALITY_ENTRY_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_QUALITY_ENTRY_PROGRESS:
            return { ...state, loading: true };
        case ADD_QUALITY_ENTRY_SUCCESS:
            return { ...state, quality_entry: [...state.quality_entry, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_QUALITY_ENTRY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_QUALITY_ENTRY_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_QUALITY_ENTRY_SUCCESS:
            return {
                ...state,
                quality_entry: state.quality_entry.map((quality_entry) =>
                    quality_entry.id === action.payload.id ? action.payload : quality_entry
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_QUALITY_ENTRY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default quality_entry_reducer;